module.exports = __webpack_public_path__ + "static/img/tishi.870b6c60.png";